import { Button, Textarea } from "@aircall/ds";
import { useTranslation } from "react-i18next";

import { useEvaluationCreateForm } from "@/hooks/useEvaluationCreateForm/useEvaluationCreateForm";
import { useEvaluationCreateFormInteractions } from "@/hooks/useEvaluationCreateFormActions/useEvaluationCreateFormActions";

import { SubmitButton } from "@/components/SubmitButton";

import { EvaluationFormFooterProps } from ".";
import { useTracking } from "./EvaluationCreateFormFooter.hooks";

export function EvaluationCreateFormFooter({
  onClickCancel,
  scoreCard,
  loading,
}: EvaluationFormFooterProps) {
  const { t } = useTranslation();
  const { form } = useEvaluationCreateForm();
  const { onClick } = useTracking();
  const { hasUnansweredQuestions, overallMaxScore, overallScore } =
    useEvaluationCreateFormInteractions();

  const handleOnClickTrack = () => {
    onClick(scoreCard);
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-col gap-3 p-4">
        <div className="flex items-center justify-between">
          <p className="text-lg font-bold">{t("evaluation.overall_title")}</p>
          <p className="text-sm font-normal">
            {t("evaluation.overall_score", {
              score: overallScore,
              maxScore: overallMaxScore,
            })}
          </p>
        </div>
        <div className="flex flex-col gap-4">
          <form.Field name="feedback">
            {(field) => (
              <Textarea
                value={field.state.value}
                onChange={(event) => {
                  field.handleChange(event.target.value);
                }}
                placeholder={t("evaluation.add_feedback")}
              />
            )}
          </form.Field>
          <div className="flex justify-end gap-2">
            <Button onClick={onClickCancel} variant="ghost" size="lg">
              {t("cancel")}
            </Button>
            <SubmitButton
              onClick={handleOnClickTrack}
              type="submit"
              loading={loading}
              disabled={hasUnansweredQuestions > 0 || loading}
              size="lg"
            >
              {t("publish")}
            </SubmitButton>
          </div>
        </div>
      </div>
    </div>
  );
}
